import axios from 'axios';

export const initFullStoryPortal = async (companyIdentifier) => {
  window['companyIdentifier'] = companyIdentifier;
};

export const trackFSEventPortal = async (name, properties) => {
  const companyIdentifier = window['companyIdentifier'];
  // console.log('trackFSEventPortal: ', companyIdentifier, name, properties);
  if (!companyIdentifier) {
    console.error('Company identifier is not set. Cannot track event.');
    return;
  }
  try {
    await axios.post('/api/visitors/return/trackPortalEvents', {
      companyIdentifier,
      eventName: name,
      properties,
    });
  } catch (error) {
    console.error('FullStory error: ', error);
  }
};
